import { Icon } from "@iconify/react";

import "./Icons.css";

const Icons = (props) => {
	return (
		<div id="socmed">
			<p>Get in touch with me</p>
			<div className="d-flex">
				{props.data.map((data, key) => (
					<a href={data.link} key={key}>
						<Icon icon={data.icon} className="icon-sosmed" style={{ background: data.color }} />
					</a>
				))}
			</div>
		</div>
	);
};

export default Icons;
